import React, { useState } from 'react';
import '../../css/modals/SimpleModal.css';
import { IoClose } from 'react-icons/io5';

function SimpleModal({ close, handlerClose, handleCloseModal }) {
	return (
		<div className={`Inscriptions ${close ? 'close' : ''}`} onClick={handleCloseModal}>
			<div className={`Inscriptions-content ${close ? 'close' : ''}`}>
				<button
					className='Inscriptions-close-btn'
					onClick={() => {
						handlerClose();
					}}
				>
					<IoClose />
				</button>

				<div className='container-info' style={{ marginBottom: '12px' }}>
					<div className='container-title'>
						<h2>💳 Opciones de pago flexibles</h2>
					</div>
					<p>
						1️⃣ El valor corresponde a <b>1 cuota mensual. </b> <br />
						✅ Financia sin complicaciones. <br />
						💰 Paga de contado y recibe <b>un descuento especial + recursos exclusivos.</b>
					</p>
				</div>
			</div>
		</div>
	);
}

export default SimpleModal;
